
// const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
//   const userRole = storage.getItem("userRole");
//   const token = storage.getItem("token");

//   const isAuthorized = allowedRoles.includes(userRole || "") && token;

//   useEffect(() => {
//     if (!isAuthorized) {
//       alert("Invalid Access")
//     }
//   }, [isAuthorized])


//   return isAuthorized ? <>{children}</> : <Navigate to="/login" replace />;
// };


import React from "react";
import { Navigate } from "react-router-dom";
import storage from "../utils/storage";

interface ProtectedRouteProps {
  requiredstep: string;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredstep, children }) => {
  const auth= storage.getItem("auth");
  const token= storage.getItem("token");
  return auth=== requiredstep ? (
    <>{children}</>
  ) : (
    token ? <Navigate to='/maindashboard' replace/>:
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
